export default __webpack_public_path__ + "static/media/logo.086e9ce2.png";